import { useMutation, useQuery } from '@apollo/client';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';

import { getPushDeviceToken } from '@flight-workspace/common-client/src/util/naverapp';
import { days } from 'common/utils';
import GET_ADS_CONSENT from 'hooks/receiveAds.gql';
import UPDATE_ADS_CONSENT from 'hooks/updateReceiveAds.gql';
import {
  GetReceiveAdsQuery,
  ReceiveAdsAssentLinkMutation,
  ReceiveAdsAssentLinkMutationVariables,
} from 'types/apollo';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

export default function AdConsentToggle() {
  const [isCheck, setIsCheck] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [updateAdsConsent] = useMutation<
    ReceiveAdsAssentLinkMutation,
    ReceiveAdsAssentLinkMutationVariables
  >(UPDATE_ADS_CONSENT);
  const { data } = useQuery<GetReceiveAdsQuery>(GET_ADS_CONSENT, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const timeoutId = setTimeout(() => setShowPopup(false), 3000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [showPopup]);

  async function onToggle() {
    const deviceToken = await getPushDeviceToken();

    updateAdsConsent({
      variables: { deviceToken, updateAssent: !isCheck },
      onCompleted() {
        setIsCheck(!isCheck);
        setShowPopup(true);
      },
    });
  }

  if (!data || data.receiveAds?.isAssent) return null;

  return (
    <div className={cx('alert')}>
      <strong className={cx('title')}>네이버 여행 이벤트·혜택 알림받기</strong>
      <button
        type="button"
        className={cx('toggle')}
        aria-checked={isCheck}
        onClick={onToggle}
        aria-label="알림받기 토글"
      />
      {showPopup && (
        <div className={cx('popover')} role="tooltip">
          {days().format('YYYY년 M월 D일')} 네이버 여행상품에
          <br />
          요청하신 광고성 정보 수신 {isCheck ? '동의' : '해제'}가 처리되었습니다
        </div>
      )}
    </div>
  );
}
